export default __webpack_public_path__ + "static/hero_partnership_mobile_img_4-9aefd5405e270a76278793d9b8002a6b.png";